import { useState } from "react";
import { Rocket, Copy } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { RippBadge } from "./primitives";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TokenLaunchSwitch = ({ token, onDone }) => {
  const [open, setOpen] = useState(false);
  const [ca, setCa] = useState("");
  const [confirm, setConfirm] = useState("");
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);
  const t = token || {};
  if (t.contract_address) {
    return (
      <div className="flex items-center gap-1.5 text-[8px] font-mono" data-testid="token-launch-done">
        <RippBadge tone="emerald" testid="token-launch-live">$RIPP LIVE</RippBadge>
        <span className="truncate max-w-[180px] text-[var(--r2-text2)]" title={t.contract_address}>{t.contract_address}</span>
        <button onClick={() => { navigator.clipboard?.writeText(t.contract_address); toast("CA copied"); }} data-testid="token-launch-copy" className="text-[var(--r2-text2)] hover:text-[var(--r2-text1)]"><Copy size={10} /></button>
        {t.announced?.tweet_id && <a href={`https://x.com/i/status/${t.announced.tweet_id}`} target="_blank" rel="noreferrer" className="text-[var(--r2-cyan)] hover:underline" data-testid="token-launch-tweet">post ↗</a>}
      </div>
    );
  }
  const dry = async () => {
    setBusy(true);
    try { const r = await axios.post(`${API}/voice/token-launch`, { contract_address: ca.trim(), dry_run: true }); setPreview(r.data.text); }
    catch (e) { toast(e.response?.data?.detail || e.message); }
    setBusy(false);
  };
  const fire = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/voice/token-launch`, { contract_address: ca.trim(), confirm });
      toast(r.data.ok ? `$RIPP announced — X ${r.data.x.tweet_id ? "posted" : "failed"} · Telegram ${r.data.telegram?.sent ? "sent" : "not sent"}` : `X post failed: ${r.data.x?.error}`);
      setOpen(false); onDone?.();
    } catch (e) { toast(e.response?.data?.detail || e.message); }
    setBusy(false);
  };
  if (!open) {
    return <button onClick={() => setOpen(true)} data-testid="token-launch-open" className="flex items-center gap-1 rounded-sm border border-[var(--r2-amber)] px-1.5 py-[2px] text-[8px] font-bold tracking-[0.14em] text-[var(--r2-amber)] hover:bg-[var(--r2-amber)]/10"><Rocket size={10} /> $RIPP CA{typeof t.days_to_token === "number" && t.days_to_token > 0 ? ` · T-${t.days_to_token}` : ""}</button>;
  }
  return (
    <div className="rounded-sm border border-[var(--r2-amber)]/60 bg-black/30 p-1.5 space-y-1 font-mono" data-testid="token-launch-panel">
      <div className="flex items-center gap-1.5 text-[8px] font-bold tracking-[0.14em] text-[var(--r2-amber)]"><Rocket size={10} /> CA SWITCH — posts X (budget override) + Telegram, shows CA on /ripp/token. One time.
        <button onClick={() => { setOpen(false); setPreview(null); setConfirm(""); }} className="ml-auto text-[var(--r2-text2)] hover:text-[var(--r2-text1)]" data-testid="token-launch-cancel">CANCEL</button></div>
      <div className="flex items-center gap-1.5">
        <input value={ca} onChange={(e) => { setCa(e.target.value); setPreview(null); }} placeholder="$RIPP mint address (base58)" data-testid="token-launch-ca" className="flex-1 min-w-0 rounded-sm border border-[var(--r2-border)] bg-transparent px-1.5 py-[2px] text-[9px] text-[var(--r2-text1)] focus:border-[var(--r2-amber)] focus:outline-none" />
        {!preview
          ? <button onClick={dry} disabled={busy || ca.trim().length < 32} data-testid="token-launch-dry" className="rounded-sm border border-[var(--r2-border)] px-1.5 py-[2px] text-[8px] font-bold tracking-[0.14em] text-[var(--r2-text2)] hover:text-[var(--r2-text1)] disabled:opacity-40">PREVIEW POST</button>
          : <>
            <input value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="type LAUNCH $RIPP" data-testid="token-launch-confirm" className="w-32 rounded-sm border border-[var(--r2-border)] bg-transparent px-1.5 py-[2px] text-[9px] text-[var(--r2-text1)] focus:border-[var(--r2-red)] focus:outline-none" />
            <button onClick={fire} disabled={busy || confirm !== "LAUNCH $RIPP"} data-testid="token-launch-fire" className="flex items-center gap-1 rounded-sm bg-[var(--r2-amber)] px-2 py-[3px] text-[8px] font-black tracking-[0.14em] text-black disabled:opacity-40"><Rocket size={10} /> {busy ? "ANNOUNCING…" : "ANNOUNCE $RIPP"}</button>
          </>}
      </div>
      {preview && <div className="text-[8px] leading-snug text-[var(--r2-text1)] line-clamp-2" title={preview} data-testid="token-launch-preview">{preview}</div>}
    </div>
  );
};
